import React from "react";
import styled from "styled-components";

import {
  Stack,
  Section,
  Card,
  Columns,
  Column,
  Hidden,
  Box,
  Text,
  TextLink,
} from "@origin-digital/ods-core";

import { IAssets, Content } from "src/components/HeroSection";
import { cloudinary } from "src/consts";
import { IHeroContent } from "src/pages/Spike/types";

const Image = styled<{
  mobileHeight?: string;
  size: "small" | "large";
  hero: IAssets["hero"];
}>(Box)`
  ${({ size, hero }) => `background: url(${cloudinary + hero[size]}) #fa5020;`}
  ${({ size, mobileHeight }) =>
    size === "small" && `height: ${mobileHeight};`}

    background-size: cover;
  background-position: center center;
`;

export const HeroSection: React.FC<{
  content: IHeroContent;
  assets: IAssets;
}> = ({ content, assets }) => (
  <>
    {/* SM / MD / LG */}
    <Hidden below="md">
      <Image size="large" hero={assets.hero}>
        <Section backgroundColor="transparent">
          <Columns>
            <Column width="1/2">
              <Card>
                <Stack space="large">
                  <Content content={content} />
                  <Text>
                    <TextLink href={content.secondaryLink.link}>
                      {content.secondaryLink.text}
                    </TextLink>
                  </Text>
                </Stack>
              </Card>
            </Column>
          </Columns>
        </Section>
      </Image>
    </Hidden>

    {/* XS */}
    <Hidden above="sm">
      <Image size="small" hero={assets.hero} mobileHeight="124px" />
      <Section>
        <Stack space="large" alignX="center">
          <Content content={content} stack />
          <Text>
            <TextLink href={content.secondaryLink.link}>
              {content.secondaryLink.text}
            </TextLink>
          </Text>
        </Stack>
      </Section>
    </Hidden>
  </>
);
